import React, { useState, useRef, useEffect } from 'react';
import { IconButton, Typography, Icon } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  AlertTemplate,
  TemplateButtonContainer,
  TemplateContainer,
  HlcDialog,
  HlcAppBar,
  HlcToolbar,
  HlcTitle,
  HlcContainer,
  HlcContainerDiv,
  BarTitle,
  SubmitButtonContainer,
  SubmitBtnText,
  HLC_FORM_STYLE,
  HLC_TITLE_STYLE,
  HLC_SCREEN_WIDTH,
  HLC_SCREEN_CONTAINER,
} from './styles';
import { get, set, size, sortBy } from 'global/lib/lodash';
import Form from 'global/components/form';
import Styles, { useScreen, Loader } from 'global/styles';
import Alert from '@mui/material/Alert';
import sendData from 'redux/actions/sendData';
import ThumbDownOutlinedIcon from '@mui/icons-material/ThumbDownOutlined';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { useTheme } from '@mui/material/styles';
import { Button } from 'global/components/Button';
import { OpHeader } from '../index';
import { ImageList } from 'global/components/image';
import SystemIcon from 'global/components/SystemIcon';
import Confirm from 'global/components/confirm';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import { UploadFiles } from 'redux/actions/imageUploader';
import { useUser } from 'global/hooks/useUser';
import { useSupersets } from 'global/hooks/useSupersets';

const TemplateExtras = (props) => {
  const theme = useTheme();
  const [cloning, setCloning] = useState(false);

  const { editMode, setEditMode, highlight, isTemplate, confirmDelete } = props;

  const type = get(highlight, 'sectionType');
  const opProps = (() => {
    if (type === 'Best Practices') {
      return {
        icon: <ThumbUpOutlinedIcon fontSize="small" />,
        title: 'Best Practices',
        color: theme.palette.success.main,
      };
    } else if (type === 'Quality Issues') {
      return {
        icon: <ThumbDownOutlinedIcon fontSize="small" />,
        title: 'Quality Opportunities',
        color: theme.palette.error.main,
      };
    }
  })();

  const sections = [
    { left: 'body', text: 'Site Observations', right: 'images', imageType: 'report-section-site-images' },
    { left: 'impactBody', title: 'impactTitle' },
    { left: 'bpBody', title: 'bpTitle', right: 'images', imageType: 'report-section-bp-images' },
  ];

  const cloneItem = async () => {
    setCloning(true);
    await props.cloneItem(highlight);
    setCloning(false);
    props.onClose();
  };

  const canShowClone = get(props, 'canShowClone', true);

  return (
    <>
      {isTemplate && (
        <AlertTemplate as={Alert} severity="error" icon={<Icon>bookmark</Icon>}>
          <div>YOU ARE VIEWING A TEMPLATE ITEM</div>
          <div>CHANGES YOU MAKE WON'T MODIFY THE ORIGINAL</div>
        </AlertTemplate>
      )}

      <TemplateButtonContainer>
        {isTemplate && canShowClone && (
          <Button onClick={cloneItem} startIcon={cloning ? <Loader size={18} /> : <Icon>add</Icon>}>
            CLONE THIS
          </Button>
        )}
        {props.isEdit !== false && highlight && (
          <Button onClick={() => setEditMode(!editMode)} color={editMode ? 'neutral' : 'secondary'} startIcon={<Icon>{editMode ? 'close' : 'edit'}</Icon>}>
            EDIT
          </Button>
        )}
        {editMode && highlight && (
          <Button color="error" onClick={confirmDelete} startIcon={<Icon>{'delete'}</Icon>}>
            Delete
          </Button>
        )}
      </TemplateButtonContainer>

      {!editMode && (
        <TemplateContainer>
          <h2>{get(highlight, 'title', '')}</h2>

          {!!get(highlight, 'superset') && (
            <div className="systemIcon">
              <SystemIcon systemId={get(highlight, 'superset.id')} />
              <div className="systemText">{get(highlight, 'superset.name')}</div>
            </div>
          )}

          <OpHeader {...opProps} />

          <div className="textContainer">
            {sections.map((section, i) => {
              return (
                <div key={i} className="textDivider">
                  <div className="left">
                    <div className="leftTitle">{get(highlight, section.title, section.text || '')}</div>
                    <div className="body" dangerouslySetInnerHTML={{ __html: get(highlight, section.left, '') }} />
                  </div>
                  <div className="right">
                    <ImageList images={get(highlight, section.right, []).filter((img) => img.collectionName === get(section, 'imageType'))} />
                  </div>
                </div>
              );
            })}
          </div>
        </TemplateContainer>
      )}
    </>
  );
};

export const Clone = async (highlight, assessment) => {
  const id = get(highlight, 'id');
  const assessment_id = get(highlight, 'assessment.id');

  const isTemplate = !assessment_id;

  //clone creates a new item, that has then takes the created item, and alters the original to have an origin
  const attributes = {
    user_id: get(highlight, 'user.id'),
    origin_id: id,
    // assessment_id: get(highlight, 'assessment_id'), //clone doens't have assessment_id
    superset_id: get(highlight, 'superset.id', get(highlight, 'supersetId')),
    section_type: get(highlight, 'sectionType'),
    title: get(highlight, 'title'),
    body: get(highlight, 'body'),
    impact_title: get(highlight, 'impactTitle'),
    impact_body: get(highlight, 'impactBody'),
    bp_title: get(highlight, 'bpTitle'),
    bp_body: get(highlight, 'bpBody'),
  };

  if (isTemplate) {
    set(attributes, 'assessment_id', get(assessment, 'id'));
  }

  const data = {
    data: {
      type: 'report-sections',
      attributes,
    },
  };

  const clone = await sendData(
    {
      url: `/report-sections`,
      method: 'post',
      data,
    },
    { build: ['reportSections'] }
  );

  //if this is a template, the newitem is actually clone, we dont' modify the original item as that is a template
  if (isTemplate) {
    return clone;
  }
};

export default (props) => {
  const theme = useTheme();
  const [formLoading, setFormLoading] = useState(true);
  const [error, setError] = useState();
  const [formState, setFormState] = useState({});
  const [editMode, setEditMode] = useState(true);
  const [confirmModal, setConfirmModal] = useState();
  const { me } = useUser();
  const formRef = useRef(null);

  const styles = Styles();
  const { isMobileXS } = useScreen();

  useBodyOverflow({ hidden: props.open });

  const { supersets } = useSupersets({ assessment: get(props, 'assessment.data') });

  const isEdit = get(props, 'highlight');

  const reset = (fs = {}) => {
    setFormState(fs);
    setError();
    setEditMode(true);
    setFormLoading(true);
  };

  const handleClose = (created) => {
    props.onClose(created);
    reset();
  };

  const formatData = async (values, isPatch) => {
    const assessment_id = get(props, 'assessment.data.id');
    const superset_id = get(values, 'superset');
    const user_id = get(me, 'id');

    const siteImages = (get(values, 'images') || []).map((p) => ({ ...p, name: p.path, caption: get(p, 'caption', '') }));
    const bpImages = (get(values, 'bpImages') || []).map((p) => ({ ...p, name: p.path, caption: get(p, 'caption', '') }));

    if (isEdit) {
      const ids = [...(get(values, 'images') || []), ...(get(values, 'bpImages') || [])].map((f) => `${f.mediaId || f.id}`);
      const missingIds = (isEdit.images || []).filter((f) => ids.indexOf(`${f.id}`) === -1);
      if (size(missingIds)) {
        await Promise.all(
          missingIds.map(async (img) => {
            await sendData({
              url: `/media/${img.id}`,
              method: 'delete',
            });
          })
        );
      }
    }

    const attributes = {
      assessment_id,
      superset_id,
      user_id,
      section_type: get(values, 'sectionType'),
      title: get(values, 'title'),
      body: get(values, 'body'),
      impact_title: get(values, 'impactTitle'),
      impact_body: get(values, 'impactBody'),
      bp_title: get(values, 'bpTitle'),
      bp_body: get(values, 'bpBody'),
      siteImages,
      bpImages,
    };

    if (isTemplate) {
      const hl = get(props, 'highlight');
      set(attributes, 'assessment_id', undefined);
      set(attributes, 'user_id', get(hl, 'user.id'));
      set(attributes, 'origin_id', get(hl, 'origin.id'));
    }

    const data = {
      data: {
        id: isPatch ? get(props, 'highlight.id') : undefined,
        type: 'report-sections',
        attributes,
      },
    };

    if (size(siteImages)) {
      await UploadFiles(data, { attributeType: 'siteImages' });
    }
    if (size(bpImages)) {
      await UploadFiles(data, { attributeType: 'bpImages' });
    }

    return data;
  };

  const formSubmit = async () => {
    try {
      setFormLoading(true);
      const isPatch = !!props.highlight;
      const data = await formatData(formRef.current.formState, isPatch);
      const created = await sendData({
        url: isPatch ? `/report-sections/${props.highlight.id}` : '/report-sections',
        method: isPatch ? 'patch' : 'post',
        data,
      });
      handleClose(created);
    } catch (err) {
      setError(`${err.message}. Please try again.`);
    } finally {
      setFormLoading(false);
    }
  };

  const formUpdate = (vals) => {
    setFormState(fs => ({ ...fs, ...vals }));
  };

  const deleteHighlight = async () => {
    try {
      setConfirmModal();
      setFormLoading(true);

      const id = get(props, 'highlight.id');
      await sendData({
        url: `/report-sections/${id}`,
        method: 'patch',
        data: {
          data: {
            type: 'report-sections',
            id,
            attributes: {
              archived: true,
            },
          },
        },
      });

      setFormLoading(false);
      handleClose();
    } catch (err) {
      setFormLoading(false);
      setError(`${err.message}. Please try again.`);
    }
  };

  const confirmDelete = () => {
    setConfirmModal({
      title: 'Delete',
      content: 'Are you sure you want to delete this Highlight?',
      onOk: deleteHighlight,
      onCancel: () => setConfirmModal(),
    });
  };

  const isTemplate = get(props, 'isTemplate');

  useEffect(() => {
    if (props.open && isEdit) {
      setFormLoading(true);
      const fs = { ...props.highlight };
      const images = (fs.images || []).filter((img) => img.collectionName.includes('report-section-site-'));
      const bpImages = (fs.images || []).filter((img) => img.collectionName.includes('report-section-bp-'));
      set(fs, 'images', images);
      set(fs, 'bpImages', bpImages);
      setFormState(fs);

      setTimeout(() => {
        setFormLoading(false);
      }, 200);

      if (isTemplate || props.isEdit === false) {
        setEditMode(false);
      }
    } else if (props.open) {
      setFormLoading(false);
    }
    if (!props.open) {
      setFormLoading(true);
    }
  }, [props.open]);

  const canSubmit = (() => {
    const hasTitle = get(formState, 'title');
    const hasSectionType = get(formState, 'sectionType');
    const hasSuperset = get(formState, 'superset');
    return hasTitle && hasSectionType && hasSuperset;
  })();

  return (
    <HlcDialog fullScreen disableScrollLock disableEscapeKeyDown open={props.open} onClose={() => handleClose()}>
      <HlcAppBar color="secondary">
        <HlcToolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => handleClose()}
            aria-label="Close"
            size="large">
            <CloseIcon />
          </IconButton>

          <BarTitle>
            <HlcTitle as={Typography} variant="h5">
              {isEdit ? (isTemplate ? 'Highlight Template' : props.isEdit === false ? 'Highlight' : 'Edit Highlight') : 'Create Highlight'}
            </HlcTitle>
          </BarTitle>
        </HlcToolbar>
      </HlcAppBar>

      {!formLoading && (
        <HlcContainer>
          {error && (
            <Alert
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setError();
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
            >
              {error}
            </Alert>
          )}

          <TemplateExtras setEditMode={setEditMode} editMode={editMode} confirmDelete={confirmDelete} {...props} />

          {editMode && !formLoading && (
            <Form
              loading={formLoading}
              showAllScreens={true}
              formStyle={HLC_FORM_STYLE}
              onSubmit={formSubmit}
              onFormState={formUpdate}
              ref={formRef}
              useHeight={false}
              screens={[
                {
                  title: 'General Info',
                  titleStyle: HLC_TITLE_STYLE,
                  screenContainerStyle: HLC_SCREEN_CONTAINER,
                  screenContainer: {
                    props: {
                      className: HLC_SCREEN_WIDTH,
                    },
                  },
                  inputs: [
                    {
                      id: 'sectionType',
                      type: 'RadioButton',
                      defaultValue: () => get(formState, 'sectionType', 'Best Practices'),
                      options: [
                        {
                          value: 'Best Practices',
                          label: (
                            <>
                              <ThumbUpOutlinedIcon style={{ color: theme.palette.success.main }} fontSize="small" /> <span>Best Practice</span>
                            </>
                          ),
                        },
                        {
                          value: 'Quality Issues',
                          label: (
                            <>
                              <ThumbDownOutlinedIcon style={{ color: theme.palette.error.main }} fontSize="small" /> <span>Quality Opportunity</span>
                            </>
                          ),
                        },
                      ],
                    },
                    {
                      id: 'title',
                      type: 'TextField',
                      defaultValue: () => get(formState, 'title'),
                      props: {
                        label: 'Title',
                        placeholder: 'Enter Title',
                      },
                    },
                    {
                      id: 'superset',
                      type: 'Select',
                      defaultValue: () => get(formState, 'superset.id', get(formState, 'supersetId', '')).toString(),
                      data: () => supersets,
                      item: (item) => {
                        return { value: item.id, title: `${item.name}` };
                      },
                      props: {
                        label: 'Construction System',
                      },
                    },
                    {
                      id: 'body',
                      type: 'RichText',
                      defaultValue: () => get(formState, 'body', ''),
                      props: {
                        label: 'Description',
                        placeholder: 'Description',
                        rows: 5,
                        multiline: true,
                      },
                    },
                    {
                      id: 'images',
                      type: 'DropArea',
                      defaultValue: () => sortBy(get(formState, 'images', []), 'orderColumn'),
                      props: {
                        label: 'Site Photos',
                        sortable: true,
                        shouldUpdateOnCaptionChange: true,
                        assessment: props.assessment,
                        uploadAllNew: true,
                        collection: 'report-section-site-images',
                        notAllowed: ['tag'],
                        imageSelect: {
                          assessment: get(props, 'assessment.data'),
                          superset_id: get(formState, 'superset'),
                          disabled: !get(formState, 'superset'),
                        },
                      },
                    },
                  ],
                },
                formState.sectionType === 'Quality Issues' && {
                  title: 'Impact',
                  titleStyle: HLC_TITLE_STYLE,
                  screenContainerStyle: HLC_SCREEN_CONTAINER,
                  screenContainer: {
                    props: {
                      className: HLC_SCREEN_WIDTH,
                    },
                  },
                  inputs: [
                    {
                      id: 'impactTitle',
                      type: 'TextField',
                      defaultValue: () => get(formState, 'impactTitle', 'Impact to Homeowner'),
                      props: {
                        label: 'Impact Title',
                        placeholder: 'Impact to Homeowner',
                      },
                    },
                    {
                      id: 'impactBody',
                      type: 'RichText',
                      defaultValue: () => get(formState, 'impactBody', ''),
                      props: {
                        label: 'Description',
                        placeholder: 'Description',
                        rows: 5,
                        multiline: true,
                      },
                    },
                  ],
                },
                formState.sectionType === 'Quality Issues' && {
                  title: 'Best Practice',
                  titleStyle: HLC_TITLE_STYLE,
                  screenContainerStyle: HLC_SCREEN_CONTAINER,
                  screenContainer: {
                    props: {
                      className: HLC_SCREEN_WIDTH,
                    },
                  },
                  inputs: [
                    {
                      id: 'bpTitle',
                      type: 'TextField',
                      defaultValue: () => get(formState, 'bpTitle', 'Best Practice'),
                      props: {
                        label: 'Best Practice Title',
                        placeholder: 'Best Practice',
                      },
                    },
                    {
                      id: 'bpBody',
                      type: 'RichText',
                      defaultValue: () => get(formState, 'bpBody', ''),
                      props: {
                        label: 'Description',
                        placeholder: 'Description',
                        rows: 5,
                        multiline: true,
                      },
                    },
                    {
                      id: 'bpImages',
                      type: 'DropArea',
                      defaultValue: () => sortBy(get(formState, 'bpImages', []), 'orderColumn'),
                      props: {
                        label: 'Best Practice Photos',
                        sortable: true,
                        shouldUpdateOnCaptionChange: true,
                        notAllowed: ['tag'],
                        assessment: props.assessment,
                        uploadAllNew: true,
                        collection: 'report-section-bp-images',
                        imageSelect: {
                          assessment: get(props, 'assessment.data'),
                          superset_id: get(formState, 'superset'),
                          disabled: !get(formState, 'superset'),
                        },
                      },
                    },
                  ],
                },
              ].filter((f) => f)}
            />
          )}
        </HlcContainer>
      )}

      {!formLoading && editMode && (
        <SubmitButtonContainer>
          <Button startIcon={<Icon style={{ fontSize: 30 }}>check</Icon>} onClick={() => formSubmit()} disabled={!canSubmit}>
            <SubmitBtnText>Save</SubmitBtnText>
          </Button>
        </SubmitButtonContainer>
      )}

      {formLoading && (
        <HlcContainerDiv className={styles.centerColumn}>
          <Loader size={40} />
        </HlcContainerDiv>
      )}

      <Confirm {...confirmModal} />
    </HlcDialog>
  );
};
